export const PROFILE_ROUTE = {
    additionalAccounts: 'additional-accounts',
    legalDetails: 'legal-details',
    individualDetails: 'individual-details',
    credentials: 'credentials',
    employees: 'employees',
    guests: 'guests',
    personal: 'personal'
}
